import { writable } from 'svelte/store';

const Store = () => {
	const { subscribe, set } = writable(false);

	// 作成
	const setErrorState = () => {
		set(true);
	};

	const offErrorState = () => {
		set(false);
	};

	return { subscribe, setErrorState, offErrorState };
};

export const netWorkErrorStore = Store();
